import { render, staticRenderFns } from "./NewsPanel.vue?vue&type=template&id=884fb522&scoped=true&"
import script from "./NewsPanel.vue?vue&type=script&lang=js&"
export * from "./NewsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NewsPanel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewsPanel.vue?vue&type=style&index=1&id=884fb522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884fb522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VHover,VImg,VLayout})
